import Icon from '../../components/Icon.vue'

Icon.register({"brands/odnoklassniki":{"width":320,"height":512,"paths":[{"d":"M275.1 334C247.7 351.4 210 358.3 185.1 360.9L206 381.5 282.3 457.8C310.2 486.4 264.8 531.1 236.6 503.5 217.5 484.1 189.5 456.1 160.3 426.9L84 503.4C55.8 530.9 10.4 485.8 38.6 457.7 58 438.3 85.7 410.3 114.9 381.4L135.5 360.8C110.9 358.2 72.6 351.7 44.9 333.9 12.3 312.9-2 300.6 10.6 274.9 18 260.3 38.3 248 65.2 269.2 65.2 269.2 101.5 298.1 160.1 298.1S255 269.2 255 269.2C281.9 248.1 302.1 260.3 309.6 274.9 322 300.6 307.7 312.9 275.1 334zM30.3 129.7C30.3 58 88.6 0 160 0S289.7 58 289.7 129.7C289.7 201.1 231.4 259.1 160 259.1S30.3 201.1 30.3 129.7zM96.3 129.7C96.3 164.8 124.9 193.4 160 193.4S223.7 164.8 223.7 129.7C223.7 94.3 195.1 65.7 160 65.7S96.3 94.3 96.3 129.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/odnoklassniki.js
// module id = null
// module chunks = 